import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';

@Component({
  selector: 'app-calendar',
  imports: [MatCalendar],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
  providers: [provideNativeDateAdapter()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarComponent {
  @Output() onChange = new EventEmitter<Date>();
  @Input() selection: Date | null | undefined = new Date();

  updateSelection($event: any) {
    this.selection = $event;
    if (this.selection) {
      this.onChange.emit(this.selection);
    }
  }
}
